import { PRESCREENING } from '@/constants';

const prescreening = {
  [PRESCREENING.APPROVAL_KEY.APPROVED]: 'Approvato',
  [PRESCREENING.APPROVAL_KEY.COMPLETED]: 'Completato',
  [PRESCREENING.APPROVAL_KEY.REJECTED]: 'Rifiutato',
  [PRESCREENING.APPROVAL_KEY.TODO]: 'In revisione',
  [PRESCREENING.APPROVAL_KEY.WALLET_FAILED]: 'Wallet fallito',
  cddForm: 'Form CDD',
  dilisense: 'Dilisense',
  dilisenseSlogan: 'Controlli gratuiti delle sanzioni e screening PeP',
  dilisenseSloganDescription:
    'Esegui i tuoi controlli delle sanzioni e gli screening PeP accedendo a una miriade di fonti governative ufficiali da tutto il mondo',
  dilisenseUpload: 'Carica il pdf di Dilisense',
  enabledWallets: 'Wallet abilitati',
  facecheck: 'Facecheck',
  facecheckVerifyProvidedVideo:
    'Verifica attentamente il video che mostra chiaramente il viso dell\'utente e che pronuncia questi tre numeri',
  facecheckVerifyUserInDocumentSameInVideo:
    'Verifica attentamente che la persona nel documento sia la stessa persona mostrata nel video sopra',
  kyc: 'KYC',
  kycStep1: 'Step 1: Controlla il Due Diligence form del cliente',
  kycStep2: 'Step 2: Verifica tutti i documenti forniti',
  kycStep3:
    'Step 3: Verifica il selfie dal vivo per sapere che l\'utente è reale',
  kycStep4: 'Step 4: Schermo per PeP, Sanzioni Crimine e Media Avversi',
  kycVerifyProvidedDocument: 'Verifica attentamente il documento fornito',
  legalRepAndUboDifferent: 'Sono diversi',
  legalRepAndUboSame: 'Il Legale Rappresentante e il UBO sono la stessa persona',
  personalData: 'Dati personali dichiarati',
  prescreening: 'Prescreening',
};

export default prescreening;
